import type { MouseEvent } from 'react';
import axios from 'axios';
import { SCREEN_SM_MIN } from '../constants/spacingConstants';

export const EXPLAINER_LEASE_PREFIX = `explainers`;
export const staticUrl = 'https://files.zillowrentals.com/leasing-web';

export function getStaticAssetUrl(filename: string) {
  return `${staticUrl}/${filename}`;
}

function isMobileViewport() {
  return document.body.getBoundingClientRect().width < SCREEN_SM_MIN;
}

function openStaticAssetAsBlob(filename: string) {
  // This condition is a special snowflake. When on mobile view, can't open directly to _self when content-type is
  // 'application/pdf'. Escape hatch is to create object URL and redirect to that
  // eslint-disable-next-line promise/catch-or-return
  axios({
    url: getStaticAssetUrl(filename),
    method: 'GET',
    responseType: 'blob',
  }).then((response) => {
    const url = window['URL']?.createObjectURL(response.data);

    // eslint-disable-next-line promise/always-return
    if (url) {
      window.open(url, '_self');
    }
  });
}

/**
 * Opens a static asset in a new tab if desktop or in current tab if on mobile
 * @param url
 */
export function openStaticAsset(filename: string) {
  if (isMobileViewport()) {
    openStaticAssetAsBlob(filename);
    return;
  }

  const newTab = window.open(getStaticAssetUrl(filename), '_blank');

  if (newTab) {
    newTab.focus();
  }
}

/** Cancels the click on mobile, where the blob escape hatch above cannot be expressed as an `href`. */
export function staticAssetLinkProps(filename: string, onClick?: () => void) {
  return {
    href: getStaticAssetUrl(filename),
    target: '_blank',
    rel: 'noopener noreferrer',
    onClick: (event: MouseEvent<HTMLAnchorElement>) => {
      onClick?.();

      if (isMobileViewport()) {
        event.preventDefault();
        openStaticAssetAsBlob(filename);
      }
    },
  };
}
